import { useEffect, useState } from "react";
import _ from "lodash";
import SurnameInput from "../../medicalDocument/form/patient/SurnameInput";
import { useApi, useHealthCenterRules } from "../../../../utils/hooks";

const PatientAutocomplete = ({ patientId, ...props }) => {
  const [patients, setPatients] = useState([]);
  const [patient, setPatient] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const api = useApi();
  const searchStrategy = useHealthCenterRules("patients")?.search?.strategy;
  const shouldSearchAsync = searchStrategy == "async";

  useEffect(() => {
    if (patientId) {
      api.patientsDetails(patientId)
        .tap(setPatient)
        .tap(patient => setPatients([patient]))
        .catch(console.error)
        .finally(() => setIsLoading(false));

      return;
    }

    if (shouldSearchAsync) return;
    if (!_.isEmpty(patients)) return;

    api.patients()
      .tap(setPatients)
      .finally(() => setIsLoading(false));
  }, [shouldSearchAsync]);

  const onAsyncSearch = (search) => {
    return api.patients({ search });
  };

  const strategyProps = shouldSearchAsync
    ? { onAsyncSearch }
    : { patients, loading: isLoading };

  return (
    <SurnameInput
      patient={patient}
      {...strategyProps}
      {...props}
    />
  );
};

export default PatientAutocomplete;